import type { BlackoutField } from './types';

export const BLACKOUT_FIELDS: Array<BlackoutField> = [];
